module.exports = __webpack_public_path__ + "img/product-y2.d2121aee.jpg";